/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_OptionalInputs */

const en_feedback_optional = /** @type {(inputs: Feedback_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`optional`)
};

/**
* | output |
* | --- |
* | "optional" |
*
* @param {Feedback_OptionalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const feedback_optional = /** @type {((inputs?: Feedback_OptionalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_OptionalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_feedback_optional(inputs)
});